import * as React from 'react';

export default function ClearIcon({ className = '', width = 16, height = 16 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 16A8 8 0 108 0a8 8 0 000 16zM6.707 5.293a1 1 0 00-1.414 1.414L6.586 8 5.293 9.293a1 1 0 001.414 1.414L8 9.414l1.293 1.293a1 1 0 001.414-1.414L9.414 8l1.293-1.293a1 1 0 00-1.414-1.414L8 6.586 6.707 5.293z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
